(function(){
    'use strict'

    angular.module('app.core')
    .factory('AuthInterceptor', AuthInterceptor);

    AuthInterceptor.$inject = ['$injector', '$q', '$location', 'UserInfoService'];

    function AuthInterceptor($injector, $q, $location, UserInfoService) {
        
        var cachedRequest = null;

        function isPublicPage(config)
        {
            return config.url.includes('crearPublicUsuario') ||
            config.url.includes('Tallas') ||
            config.url.includes('EstadosVacunacion') ||
            config.url.includes('usuarios-public') ||
            config.url.includes('recuperarPassword') ||
            config.url.includes('popup.html') ||
            config.url.includes('datepicker');
        }

        var authInterceptor = {  
            request: function (config) {  
                var accessToken = UserInfoService.getToken();

                if(!isPublicPage(config))
                {
                    if (accessToken == null || accessToken == "undefined") { 
                        $location.path( "/" ); 
                    }  
                    else {
                        config.headers["Access-Control-Allow-Origin"] = "*";
                        config.headers["Access-Control-Allow-Methods"] = "*";
                        config.headers["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept, Authorization, X-Auth-Token";
                        config.headers["Authorization"] = "bearer " + accessToken;
                    }                     
                }

                return config;  
            },  
  
            requestError: function (config) {  
                $location.path( "/" );   
                return config;  
            },  
  
            response: function (res) {  
                return res;  
            },  
  
            responseError: function (res) {  
                switch (res.status) {
                    case 401:
                        var deferred = $q.defer();
                        if(!cachedRequest){
                            cachedRequest = $injector.get("LoginService").refreshToken(UserInfoService.getRefreshToken(), "refresh_token");
                        }
                        //When Promise is resolved, new Access Token is returend 
                        cachedRequest.then(function(accessToken) {
                            cachedRequest = null;
                            if (accessToken) {
                                UserInfoService.setRefreshTokenInfo(accessToken.data);
                                //Resend this request when Access Token is renewed
                                $injector.get("$http")(res.config).then(function(resp) {
                                    //Resolve this request (successfully this time)
                                    deferred.resolve(resp);
                                },function(resp) {
                                    UserInfoService.userInfo.isAuthenticated = false;
                                    $location.path( "/" );
                                    deferred.reject(resp);
                                });
                            } else {
                                //If any error occurs reject the Promise
                                UserInfoService.userInfo.isAuthenticated = false;
                                $location.path( "/" );
                                deferred.reject(res);
                            }
                        }, function(response) {
                            //If any error occurs reject the Promise
                            if(response.data.error === "invalid_grant")
                            {
                                UserInfoService.userInfo.isAuthenticated = false;
                                $location.path( "/" );
                            }
                            cachedRequest = null;
                            deferred.reject(response);
                        });
                        return deferred.promise;
                    //case 400:
                    case 403:
                    case 404:
                        UserInfoService.userInfo.isAuthenticated = false;
                        $location.path( "/" );
                        break;
                }
                return $q.reject(res);  
            }  
        };  
  
        return authInterceptor;  
    }
})();